import {
  AutoAssignSettingsUpdatePayload,
  CreateWorkspacePayload,
  TrackingPageSettingsUpdatePayload,
  UpdatePublicFormSettingsPayload,
  UpdateWorkspacePayload,
  Workspace,
} from "@web-app/types";
import http from "@web-app/utils/http";

const base_url = "/workspaces";

export const getCurrentWorkspace = async () => {
  return http
    .get<Workspace>("/currentWorkspace")
    .then((response) => response.data);
};

export const create = async (payload: CreateWorkspacePayload) => {
  return http
    .post<Workspace>(base_url, payload)
    .then((response) => response.data);
};

export const update = async (
  id: string,
  payload: Partial<UpdateWorkspacePayload>,
) => {
  return http
    .patch<Workspace>(`${base_url}/${id}`, payload)
    .then((response) => response.data);
};

export const updateWorkspacePublicFormSettings = async (
  payload: Partial<UpdatePublicFormSettingsPayload>,
) => {
  return http
    .patch(`/currentWorkspace/publicFormSettings`, payload)
    .then((response) => response.data);
};

export const updateWorkspaceTrackingPageSettings = async (
  payload: Partial<TrackingPageSettingsUpdatePayload>,
) => {
  return http
    .patch(`/currentWorkspace/trackingPageSettings`, payload)
    .then((response) => response.data);
};

export const updateAutoAssignSettings = async (
  payload: AutoAssignSettingsUpdatePayload,
) => {
  return http
    .patch(`/currentWorkspace/autoAssignSettings`, payload)
    .then((response) => response.data);
};
